<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Input from "@components/form/Input.svelte";
	import type { Snippet } from "svelte";
	import type { HTMLAttributes } from "svelte/elements";

	let {
		group = $bindable(),
		/* eslint-disable prefer-const */
		value,
		text,
		note,
		name,
		priceFormatted,
		image,
		checked,
		...props
		/* eslint-enable prefer-const */
	}: {
		group?: string;
		name: string;
		value: string;
		text: string;
		note?: string;
		priceFormatted?: string;
		image?: Snippet;
		checked?: boolean;
	} & HTMLAttributes<HTMLLabelElement> = $props();
</script>

<label
	{...props}
	class={[
		"border border-fcrlightgray-300 bg-fcrlightgray-200 rounded-[1.5rem] flex items-center p-6 cursor-pointer has-[input:checked]:border-transparent has-[input:checked]:outline outline-fcrdarkgray",
		props.class,
	]}
>
	<div class="mr-10">
		<Input type="radio" {name} {value} bind:group {checked} />
	</div>
	{#if image}
		<div class="mr-4">
			{@render image()}
		</div>
	{/if}
	<div class="font-antipol font-medium text-4.5">
		<Formatted text={note ? `${text} small[[(${note})]]` : text} />
	</div>
	{#if priceFormatted}
		<div class="font-medium text-base ml-auto pl-4">
			<Formatted text={priceFormatted} />
		</div>
	{/if}
</label>
